var _path, _circle, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSixthBenefit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4545 39.9375H10.5454M26.4545 39.9375L31.7576 43.6562L28.0455 44.1875M26.4545 39.9375C27.7821 37.61 28.9312 35.5068 29.848 33.5625M10.5454 39.9375L5.24242 43.6562L8.42424 44.1875M10.5454 39.9375C9.21775 37.61 8.06868 35.5068 7.15184 33.5625M8.42424 44.1875C8.42424 44.1875 7.66336 47.4211 7.89394 49.5C8.8367 58 18.5 58 18.5 58C18.5 58 16.1073 50.0312 20.0909 50.0312C23.803 50.0312 22.2121 55.875 22.2121 55.875C22.2121 55.875 28.5758 55.3438 28.5758 48.4375C28.5758 46.6487 28.4171 45.5398 28.0455 44.1875M8.42424 44.1875V44.1875C14.7693 44.8938 21.1721 44.9123 27.5211 44.2428L28.0455 44.1875M4.92202 22.9375C5.55483 19.3551 7.98477 15.8953 12.8541 11.7761L16.5624 8.63908C17.6808 7.69293 19.319 7.69293 20.4375 8.63908L24.1457 11.7761C29.0151 15.8953 31.445 19.3551 32.0778 22.9375M4.92202 22.9375L1 26.125V33.5625H7.15184M4.92202 22.9375C4.3485 26.1843 5.25115 29.5319 7.15184 33.5625M32.0778 22.9375L35.4697 26.125L36 33.5625H29.848M32.0778 22.9375C32.6514 26.1843 31.7487 29.5319 29.848 33.5625",
    stroke: "url(#paint0_linear_41_3271)",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 23.5,
    r: 5.5,
    stroke: "url(#paint1_linear_41_3271)",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_41_3271",
    x1: 36,
    y1: 7,
    x2: 1,
    y2: 7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DCBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2295EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_41_3271",
    x1: 25,
    y1: 17,
    x2: 12,
    y2: 17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DCBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2295EF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSixthBenefit);
export default __webpack_public_path__ + "static/media/sixth_benefit.4aa9b0482117a39eec9694d025fcaafb.svg";
export { ForwardRef as ReactComponent };